import React from "react";
import Grid from "@material-ui/core/Grid";
import Layout from "../../components/common/hoc/Layout";
import { useTranslation } from "react-i18next";

const Feedback = () => {
  const { t } = useTranslation("translation");

  return (
    <Layout title={t("feedback.title")}>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12} sm={12} lg={12}>
          <iframe
            style={{ maxWidth: "100%" }}
            src="https://docs.google.com/forms/d/e/1FAIpQLSeigBEVxssLoALi3l6RFnWAsoY9z88qH6LI0m0t2d4rTit5eg/viewform?embedded=true"
            width="1920"
            height="1285"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
          >
            Loading…
          </iframe>
        </Grid>
      </Grid>
    </Layout>
  );
};

export { Feedback };
